import React from 'react'
import Button, { TYPES } from 'components/Button'

const SectionRemoved = (props) => {
  const {
    sectionTitle,
    addBackHandler,
    staticText,
    sectionId,
  } = props
  const onAddItBack = () => {
    addBackHandler()
  }
  const bodyText = `${sectionTitle} ${staticText.get('removedIt')}`
  return (
    <div className="section-removed" data-page-manager-section-id={sectionId}>
      <div className="section-removed__content">
        {bodyText}
        <Button
          type={TYPES.LINK}
          onClick={onAddItBack}
        >
          {staticText.get('undo')}
        </Button>
      </div>
    </div>
  )
}

export default SectionRemoved
